/* eslint no-console:0 */
export function warn(msg) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return console && console.warn && console.warn.apply(console, ['WARN LOG:', msg].concat(args));
}